import React from 'react';
import './TitleOverview.scss';

const TitleOverview = ({ children, overview }) => (
  <div className="title-overview">
    <h3 className="title-overview-title">{children}</h3>
    <p className="title-overview-content">{overview}</p>
  </div>
);

export default TitleOverview;
